





import Vue from 'vue'
import { Modals } from '@/constants/modals'

import type { TPaidLabelTheme } from '@/models/paidLabel'

interface Methods {
  handleOpenModal: () => void
}

interface Computed {
  container: string
  containerClass: string
}

interface Props {
  theme: TPaidLabelTheme
  component?: string
}

export default Vue.extend<{}, Methods, Computed, Props>({
  props: {
    theme: {
      default: () => 'hidden',
    },
    component: {
      default: () => ''
    },
  },
  computed: {
    container(): string {
      return this.component || 'div'
    },
    containerClass(): string {
      return this.theme
    },
  },
  methods: {
    handleOpenModal(): void {
      this.$modal.show(Modals.TariffsModal)
    }
  }
})
